import React, { useEffect, useState } from "react";

export default function ChatRoom(props) {
  const { loginInfo, activeChRoom } = props;
  // 채팅방 이름 변경
  const [isChangeChatRoomTitle, setIsChangeChatRoomTitle] = useState(false);
  const [chatRoomTitle, setChatRoomTitle] = useState("");
  // 채팅방 메뉴 오픈
  const [isOpenMenu, setIsOpenMenu] = useState(false);

  useEffect(() => {
    if (activeChRoom) {
      setChatRoomTitle(activeChRoom.chatRoomTitle);
    }
  }, [activeChRoom]);

  console.log("props", activeChRoom);
  return (
    <div className="bg-white w-100 h-100 border-left d-flex flex-column position-relative p-3">
      {/*타이틀*/}
      {!isChangeChatRoomTitle && (
        <div className="pb-3 d-flex flex-row justify-content-between align-items-center">
          <div className="d-flex flex-row align-items-center">
            {loginInfo.selfChatRoomKey === activeChRoom.crmMainKey && (
              <span
                className="d-inline-flex flex-row justify-content-center align-items-center bg-freiscop text-white rounded-circle font-size-08 font-weight-bold"
                style={{
                  width: 18,
                  height: 18,
                  marginRight: 3,
                }}
              >
                나
              </span>
            )}
            <p className="h6 mb-0 font-weight-bold">{chatRoomTitle}</p>
          </div>
          <div>
            <span className="px-2 cursor_pointer">
              <i className="fa-solid fa-magnifying-glass" />
            </span>
            <span className="cursor_pointer position-relative">
              <i
                className="fa-solid fa-bars px-2"
                onClick={() => setIsOpenMenu(true)}
              />
              {isOpenMenu && (
                <>
                  <div
                    className="position-fixed cursor_pointer vw-100 vh-100"
                    onClick={() => setIsOpenMenu(false)}
                    style={{ top: 0, left: 0, background: "rgba(0,0,0,0.1)" }}
                  />
                  <div
                    className="position-absolute shadow-sm border rounded bg-white overflow-hidden"
                    style={{
                      top: "calc(100% + 4px)",
                      right: 6,
                      minWidth: 140,
                      zIndex: 1,
                    }}
                  >
                    <p className="px-2 py-1 cursor_pointer_bg_light">
                      <i className="fa-solid fa-users mr-1 font-size-09 text-secondary" />
                      대화 상대 보기
                    </p>
                    <p className="px-2 py-1 cursor_pointer_bg_light">
                      <i className="fa-solid fa-user-plus mr-1 font-size-09 text-secondary" />
                      대화 상대 초대
                    </p>
                    <p className="px-2 py-1 cursor_pointer_bg_light">
                      <i className="fa-regular fa-folder-open mr-1 font-size-09 text-secondary" />
                      파일
                    </p>
                    <p className="px-2 py-1 cursor_pointer_bg_light">
                      <i className="fa-solid fa-bullhorn mr-1 font-size-09 text-secondary" />
                      공지
                    </p>
                    <p className="px-2 py-1 cursor_pointer_bg_light">
                      <i className="fa-regular fa-bell mr-1 font-size-09 text-secondary" />
                      <i className="fa-regular fa-bell-slash mr-1 font-size-09 text-secondary" />
                      알림 켜기
                    </p>
                    <p className="px-2 py-1 cursor_pointer_bg_light border-top">
                      <i className="fa-solid fa-rotate mr-1 font-size-09 text-secondary" />
                      채팅방 이름변경
                    </p>
                    <p className="px-2 py-1 cursor_pointer_bg_light">
                      <i className="fa-solid fa-arrow-right-from-bracket mr-1 font-size-09 text-secondary" />
                      나가기
                    </p>
                  </div>
                </>
              )}
            </span>
          </div>
        </div>
      )}
      {/*메세지 이력*/}
      <div className="flex-fill bg-blue-light rounded-xl-top"></div>
      {/*메세지 입력*/}
      <div className="bg-blue-light border-top rounded-xl-bottom p-3">
        메시지 입력
      </div>
    </div>
  );
}
